export default {"src":"/_next/static/media/armchair-700.8b06866e.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};